module.exports = __webpack_public_path__ + "resources/img/img-secuve-tos-01-m-jp.a2d1d5b77d27a5d259aee90da4220f56.png";